import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

export const PRIVACY_LAST_UPDATED = 'July 12, 2026';

function Privacy() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <header className="legal-header">
          <Link to="/" className="legal-logo">
            around
          </Link>
          <h1>Privacy Policy</h1>
          <p className="legal-updated">Last updated: {PRIVACY_LAST_UPDATED}</p>
        </header>

        <section>
          <h2>1. Overview</h2>
          <p>
            This Privacy Policy explains what information Around (&ldquo;we,&rdquo;
            &ldquo;us,&rdquo; or &ldquo;our&rdquo;) collects when you use the Around website,
            applications, and related services (the &ldquo;Service&rdquo;), how we use and share
            it, and the choices you have. By using the Service, you agree to the practices
            described here and to our <Link to="/terms">Terms of Service</Link>.
          </p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          <p>
            <strong>Account information.</strong> When you sign up we collect your name, email
            address, and a password (stored only as a cryptographic hash — we never store your
            plain-text password).
          </p>
          <p>
            <strong>Profile information.</strong> Information you choose to add to your profile,
            such as your handicap, home course, courses you play, playing style, preferred tees,
            pace preference, bio, city and state, profile photo, gender, availability, and GHIN
            number and GHIN-verified handicap if you connect one.
          </p>
          <p>
            <strong>Location.</strong> If you allow it, we collect your approximate location
            (latitude and longitude) to show you nearby golfers, rounds, and tee times. You can use
            most of the Service without sharing precise location.
          </p>
          <p>
            <strong>Content you create.</strong> Posts, comments, likes, round and tee-time
            listings, connection requests and notes, and messages you exchange with other users.
          </p>
          <p>
            <strong>Usage and technical data.</strong> Like most services, our servers log basic
            technical information such as IP address, browser type, and pages requested. We also
            collect error reports (via Sentry) to find and fix bugs.
          </p>
        </section>

        <section>
          <h2>3. How We Use Your Information</h2>
          <ul>
            <li>to provide the Service — matching you with nearby golfers, showing your profile
              to others, delivering messages and notifications;</li>
            <li>to secure the Service — authenticating you, preventing abuse, enforcing our
              Terms;</li>
            <li>to communicate with you about the Service, such as password-reset emails;</li>
            <li>to fix problems and improve the Service.</li>
          </ul>
          <p>We do not sell your personal information, and we do not use it for third-party
            advertising.</p>
        </section>

        <section>
          <h2>4. How Your Information Is Shared</h2>
          <p>
            <strong>With other users.</strong> Your profile (name, photo, handicap, courses, city
            and state, bio, availability, and similar profile fields) is visible to other
            Around users. Your posts, comments, and marketplace listings are visible to other
            users. Messages are visible to the participants of the conversation. Your precise
            coordinates are never shown to other users — only approximate distance and your listed
            city.
          </p>
          <p>
            <strong>With service providers.</strong> We use trusted providers to run the Service:
            hosting and database (Railway), web hosting (Vercel), email delivery for account
            emails, and error monitoring (Sentry). They process data only as needed to provide
            those services.
          </p>
          <p>
            <strong>For legal reasons.</strong> We may disclose information if required by law or
            if reasonably necessary to protect the safety, rights, or property of our users or the
            public.
          </p>
        </section>

        <section>
          <h2>5. Cookies</h2>
          <p>
            We use a single essential cookie to keep you signed in. We do not use advertising or
            cross-site tracking cookies.
          </p>
        </section>

        <section>
          <h2>6. Data Retention</h2>
          <p>
            We keep your information for as long as your account exists. If you delete your account
            (or ask us to), we delete your profile and associated data, except where limited
            retention is required by law or needed to resolve disputes. Messages you sent to other
            users may remain visible to them.
          </p>
        </section>

        <section>
          <h2>7. Security</h2>
          <p>
            We take reasonable measures to protect your information: passwords are hashed, traffic
            is encrypted in transit (HTTPS), and access to production systems is restricted. No
            system is perfectly secure, so we cannot guarantee absolute security.
          </p>
        </section>

        <section>
          <h2>8. Your Choices and Rights</h2>
          <ul>
            <li>You can view and edit your profile information at any time in the app.</li>
            <li>You can decline to share your location and still use the Service.</li>
            <li>
              You can request a copy of your data or deletion of your account by emailing us at
              the address below. Depending on where you live, you may have additional rights (such
              as access, correction, and deletion) under laws like the California Consumer Privacy
              Act or the EU General Data Protection Regulation — we honor such requests regardless
              of where you live.
            </li>
          </ul>
        </section>

        <section>
          <h2>9. Children&rsquo;s Privacy</h2>
          <p>
            The Service is not directed to children under 13, and we do not knowingly collect
            personal information from children under 13. If you believe a child under 13 has
            created an account, contact us and we will delete it.
          </p>
        </section>

        <section>
          <h2>10. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. If we make material changes, we
            will notify you through the Service. The &ldquo;Last updated&rdquo; date above reflects
            the current version.
          </p>
        </section>

        <section>
          <h2>11. Contact Us</h2>
          <p>
            Questions or requests about your data? Contact us at{' '}
            <a href="mailto:dkoski1995@gmail.com">dkoski1995@gmail.com</a>.
          </p>
        </section>

        <footer className="legal-footer">
          <Link to="/terms">Terms of Service</Link>
          <span aria-hidden="true">·</span>
          <Link to="/">Back to around</Link>
        </footer>
      </div>
    </div>
  );
}

export default Privacy;
